import { BehaviorSubject, EMPTY, Observable, Subject, catchError, finalize, first, firstValueFrom, of, take, takeUntil, throwError } from "rxjs";
import { AlertService } from "../services/alert.service";
import { inject } from "@angular/core";
import Paging from "../model/api/generic/paging";

export default class InfiniteScrollSubject<T> extends BehaviorSubject<T[]> {

  //#region Propiedades

  public loading = new BehaviorSubject<boolean>(false)
  public totalItems: number = null
  private lista: T[] = []
  private alertService: AlertService
  public page: number = 1
  public HasMoreItems = new BehaviorSubject<boolean>(true)
  public search: string = null
  private nextBusqueda$ = new Subject<void>()

  constructor(
    private request: (requestObj: {
      start: number,
      limit: number,
      search?: string
    }) => Observable<Paging<T>>,
    public limit: number,
    private requestById?: (id: any) => Observable<T>
  ) {
    super([])
    this.alertService = inject(AlertService)
  }

  //#endregion

  //#region Búsqueda

  public loadPage(): void {
    this.nextBusqueda$.next()
    try {
      let pageToLoad = this.page
      this.page++
      this.loading.next(true)
      let objSearch: { start: number, limit: number, search?: string } = {
        start: (pageToLoad - 1) * this.limit,
        limit: this.limit
      }
      if (this.search !== undefined) {
        objSearch.search = this.search
      }
      this.request(objSearch).pipe(
        takeUntil(this.nextBusqueda$),
        take(1),
        catchError((ex) => {
          this.loading.next(false)
          console.error(ex)
          this.alertService.showMessage(ex?.message || 'Se ha producido un error', 'Error al cargar los datos')
          return EMPTY
        }),
        finalize(() => {
          this.loading.next(false)
        })
      ).subscribe((result) => {
        this.totalItems = result.total
        if (pageToLoad == 1) {
          this.lista = []
        }
        this.lista.push(...result.collection)
        this.HasMoreItems.next(this.totalItems != this.lista.length)
        this.next(this.lista)
      })
    } catch (ex) {
      this.loading.next(false)
      console.error(ex)
      this.alertService.showMessage(ex?.message || 'Se ha producido un error', 'Error al cargar los datos')
      throw ex
    }
  }

  public async reset(): Promise<void> {
    this.page = 1
    this.next([])
    await this.loadPage()
  }

  public async getById(Id: any): Promise<T> {
    let item = await firstValueFrom(this.requestById(Id))
    return item
  }

  //#endregion

}